<form [formGroup]="lessorAreaMakerArrayForm" >

<div class="display_table">
  <!-- <div class="search_container">
    <input type="text" class="default_input search" placeholder="Search" />
    <i class="ti-search"></i>
  </div> -->

  <div class="head" style="grid-template-columns: 0.2fr 1fr 0.4fr 0.4fr 0.4fr 0.4fr 0.4fr 0.4fr 0.4fr 0.4fr 1fr;">
    <span class="item">S/N</span>
    <span class="item">Description</span>
    <span class="item">Lat Deg</span>
    <span class="item">Lat Min</span>
    <span class="item">Lat Sec</span>
    <span class="item">Long Deg</span>
    <span class="item">Long Min</span>
    <span class="item">Long Sec</span>
    <span class="item">Northing</span>
    <span class="item">Easting</span>
    <span class="item">Remark</span>
  </div>
  <div class="body_content">
    <div style="grid-template-columns: 0.2fr 1fr 0.4fr 0.4fr 0.4fr 0.4fr 0.4fr 0.4fr 0.4fr 0.4fr 1fr;" class="the_body" *ngFor="let lessor of lessorAreaMakerArrayForm.get('LessorAreaMaker')['controls']; index as i"
    (click)="onEdit(lessor.value, i)">
      <span class="content">{{i + 1}} </span>
      <span class="content">{{lessor.value.LessorAreaMakerDesc}}</span>
      <span class="content">{{lessor.value.PobLatitudeDegree}}</span>
      <span class="content">{{lessor.value.PobLatitudeMin}}</span>
      <span class="content">{{lessor.value.PobLatitudeSec}}</span>
      <span class="content">{{lessor.value.PobLongitudeDegree}}</span>
      <span class="content">{{lessor.value.PobLongitudeMin}}</span>
      <span class="content">{{lessor.value.PobLongitudeSec}}</span>
      <span class="content">{{lessor.value.LessorAreaMakerNorthing}}</span>
      <span class="content">{{lessor.value.LessorAreaMakerEasting}}</span>
      <span class="content">{{lessor.value.LessorAreaMakerRemarks}}</span>
      <span class="content" (click)=$event.stopImmediatePropagation()><i class="ti-trash" (click)="onDelete(lessor.value, i)"></i></span>

    </div>

  </div>
</div>
</form>
